import React, { useEffect } from "react";
import "../css/BottomBar.css";
import { patientsSidebarOptions, sidebarOptions } from "../constant/Constant";
import SidebarItem from "./SidebarItem";
import { useLocation, useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import { useAtom } from "jotai";
// import { userRoleAtom } from "remote/userRoleAtom";
import { userRoleAtom } from "../../setup/atom/Atom";
import { useCurrentRole } from "../../../../_helper/constant/Permission";
import { useUserFilter } from "../../../../_helper/actions/app/items";
import { ApiEndPoint } from "../../../../_helper/constant/api-types";
import { checkPermission } from "../../../../roles_and_permissions/_features";
import { permissionAtom } from "../../../../_helper/constant/constant-atom";
const BottomBar = () => {
  const navigateTo = useNavigate();
  const location = useLocation();
  const [userRole, setUserRole] = useAtom(userRoleAtom);
  const { role_id } = useCurrentRole();
  const [permission] = useAtom(permissionAtom);

  // const { data: userData, isSuccess: userIsSuccess } = useUserFilter(
  //   `${ApiEndPoint.USERS}/${role_id}`,
  //   `?fields=id,first_name,last_name,role.*`,
  //   role_id ? true : false
  // );

  const userData = {};
  const userIsSuccess = false;

  useEffect(() => {
    if (userIsSuccess) {
      setUserRole(userData);
    }
  }, [userIsSuccess]);
  const navigateHandler = (route) => {
    navigateTo(route);
  };

  return (
    <>
      {location.pathname !== "/p/chat" && <TopBar userRole={userRole} />}
      <div className="bottombar-main">
        {(userRole?.role?.name === "Patient"
          ? patientsSidebarOptions
          : sidebarOptions
        ).map((option, i) => {
          if (
            option.name !== "Notifications" &&
            option.name !== "Chat" &&
            option.name !== "Finance and Accounting"
          ) {
            return (
              checkPermission(
                permission?.allowed_features,
                option?.featureId
              ) && (
                <SidebarItem
                  type={"bottombar"}
                  activeIcon={option.activeIcon}
                  inactiveIcon={option.inactiveIcon}
                  key={option.id}
                  className={"bottombar-item"}
                  activeClass={"bottombar-item-active"}
                  route={option.route}
                  onClick={() => navigateHandler(option.route)}
                  name={option?.name}
                />
              )
            );
          }
        })}
      </div>
    </>
  );
};

export default BottomBar;
